import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export const Faq = () => (
  <section id="faq" className="mx-auto max-w-4xl px-5 py-24 sm:px-8 lg:py-32">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8 }}
      className="mb-14 text-center"
    >
      <p className="mb-3 font-mono-tech text-xs tracking-[0.3em] text-gold-400">
        05 — PERGUNTAS FREQUENTES
      </p>
      <h2 className="font-serif-display text-3xl font-normal leading-tight tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
        Clareza antes do <em className="gold-text italic">carimbo.</em>
      </h2>
    </motion.div>

    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: 0.1 }}
    >
      <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-item-${i}`}
            className="border-gold-400/15"
          >
            <AccordionTrigger
              data-testid={`faq-question-${i}`}
              className="py-5 text-left font-serif-display text-lg text-slate-100 hover:text-gold-200 hover:no-underline sm:text-xl"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm font-light leading-relaxed text-slate-400">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </motion.div>
  </section>
);
